import {
    FETCH_NOTIFICATION_UNREAD_COUNT_SUCCESS,
    FETCH_NOTIFICATION_UNREAD_COUNT_ERROR,
    FETCH_NOTIFICATION_INBOX_SUCCESS,
    FETCH_NOTIFICATION_INBOX_ERROR,
    CLEAR_NOTIFICATIONS,
    LOGOUT,
    SELECT_USER
} from "../actions/actions";

const initialState = {
    unreadCount: 0,
    inbox: {
        items: [],
        hasMore: false
    },
    error: null
};

export function notifications(state = initialState, action) {
    switch (action.type) {
        case FETCH_NOTIFICATION_UNREAD_COUNT_SUCCESS:
            return {...state, unreadCount: action.result.unread, error: null};
        case FETCH_NOTIFICATION_UNREAD_COUNT_ERROR:
            return {...state, error: action.result};
        case FETCH_NOTIFICATION_INBOX_SUCCESS:
            return {
                ...state,
                inbox: {
                    items: action.result.items,
                    hasMore: action.result.hasMore
                },
                error: null
            };
        case FETCH_NOTIFICATION_INBOX_ERROR:
            return {...state, error: action.result};
        case CLEAR_NOTIFICATIONS:
        case SELECT_USER:
        case LOGOUT:
            return initialState;
        default:
            return state;
    }
}
